<template>
    <div class="content">
        <TopBar barTheme="white" :barStyle="`background: url(${require('@/assets/images/personal_top_bg.png')}) no-repeat; background-size: 100%;`">
            <span class="page-title" slot="title">填写收件信息</span>
        </TopBar>
        <div class="receiving-info">
            <div class="pro-box wrap">
                <div class="pic-wrap vc">
                    <img :src="proImg" :alt="product.Name">
                </div>
                <div class="text-wrap">
                    <h3>{{product.Name}}</h3>
                    <p v-if="product.Price">所需积分：<span class="cur">{{product.Price}}积分</span></p>
                    <p>数量：<span class="black">1</span></p>
                </div>
            </div>
            <div class="info-box wrap">
                <div class="item-title vc"><i class="icon icon-line"></i>填写收货信息</div>
                <div class="item-detail">
                    <ul>
                        <li class="vc"><span>收件人</span><input type="text" v-model="userName" placeholder="请填写收件人姓名"></li>
                        <li class="vc" v-bind:class="{error: isTelError}"><span>手机号码</span><input type="text" v-model="userTel" placeholder="请填写收件人手机号码" @blur="checkTelError"></li>
                        <li class="vc"><span>所在地区</span><div @click="showSelect"><input type="text" v-model="userAdd" placeholder="省市区县、乡镇" readonly></div></li>
                        <li class="vc"><span>详细地址</span><input type="text" v-model="address" placeholder="街道、楼牌号等"></li>
                    </ul>
                </div>
                <div class="info-tip">*以上信息确认后，不可修改。</div>
            </div>
            <div class="city-select" v-if="showSelectLayer" @click.self="hideLayer">
                <div class="city-list">
                    <div class="list-title hc">请选择所在地区</div>
                    <div class="list-body">
                        <div class="list-item list-p">
                            <div class="selected-wrap selected-p"><span :class="`${isSelectProvince} el`">{{provinceVal}}</span></div>
                            <div class="options-wrap">
                                <ul>
                                    <li v-for="(province, index) in cityList" :key="index"><span :class="`${checkProvinceIndex === index ? 'cur' : ''} el`" @click="selectProvince(index)">{{province.p}}</span></li>
                                </ul>
                            </div>
                        </div>
                        <div class="list-item list-c" v-if="cityArr.length > 0">
                            <div class="selected-wrap selected-c"><span :class="`${isSelectCity} el`">{{cityVal}}</span></div>
                            <div class="options-wrap">
                                <ul>
                                    <li v-for="(city, index) in cityArr" :key="index"><span :class="`${checkCityIndex === index ? 'cur' : ''} el`" @click="selectCity(index)">{{city.n}}</span></li>
                                </ul>
                            </div>
                        </div>
                        <div class="list-item list-z" v-if="zoneArr && zoneArr.length > 0">
                            <div class="selected-wrap selected-z"><span :class="`${isSelectZone} el`">{{zoneVal}}</span></div>
                            <div class="options-wrap">
                                <ul>
                                    <li v-for="(zone, index) in zoneArr" :key="index"><span :class="`${checkZoneIndex === index ? 'cur' : ''} el`" @click="selectZone(index)">{{zone.s}}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bot-btn hvc">
                <a class="btn-item btn-submit hvc" @click="subInfo" href="javascript: void(0)">确认提交</a>
            </div>
            <div class="message-layer" v-if="msgShow">
                <div class="message-content">
                    <div class="msg-text">
                        <h3>{{msgTitle}}</h3>
                        <div class="msg-tip hvc" v-html="msgTip"></div>
                    </div>
                    <div class="msg-icon hc">
                        <i class="icon icon-error" v-if="msgType === 'error'"></i>
                        <i class="icon icon-success" v-if="msgType === 'success'"></i>
                        <i class="icon icon-checking" v-if="msgType === 'checking'"></i>
                    </div>
                    <div class="bottom-btn" v-if="msgType === 'error'">
                        <a class="btn-item btn-close hvc" href="javascript: void(0)" @click="closeMsg">关闭</a>
                    </div>
                    <div class="bottom-btn" v-if="msgType === 'success' || msgType === 'checking'">
                        <a class="btn-item btn-continue hvc" href="javascript: void(0)" @click="continueExchange">继续兑换</a>
                        <a class="btn-item btn-see hvc" href="javascript: void(0)" @click="see">查看我的礼品</a>
                    </div>
                </div>
            </div>
        </div>
        <Loading :loading="loading"></Loading>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import TopBar from '@/components/top-bar/'
    import cityList from './city'
    import {checkTel, combineObject} from '@/libs/tools'
    import Loading from '@/components/loading'
    export default {
        name: 'receivingInfo',
        components: {
            TopBar,
            Loading
        },
        data: () => {
            return {
                productId: null,
                product: {},
                proImg: '',
                userName: '',
                userTel: '',
                isTelError: false,
                userAdd: '',
                address: '',
                showSelectLayer: false,
                cityList,
                isSelectProvince: '',
                checkProvinceIndex: null,
                provinceVal: '请选择',
                cityArr: [],
                isSelectCity: '',
                checkCityIndex: null,
                cityVal: '请选择',
                zoneArr: [],
                isSelectZone: '',
                checkZoneIndex: null,
                zoneVal: '请选择',
                lockSubmit: false,
                msgType: '',
                msgShow: false,
                msgTitle: '',
                msgTip: '',
                loading: false,
                queryObj: {}
            }
        },
        mounted () {
            this.queryObj = this.$route.query
            this.productId = this.$route.query.Id
            this.getUserLevelPrivilege(this.productId)
                .then(res => {
                    this.product = res
                    this.proImg = res.Pictures[0]
                })
            this.getCustomerAddress()
                .then(res => {
                    if (res.Name !== null && res.Province !== null) {
                        this.userName = res.Name
                        this.userTel = res.Mob
                        this.userAdd = res.City
                        this.address = res.Address

                        this.provinceVal = res.Province
                        this.cityVal = res.City
                        this.zoneVal = res.DistrictCounty
                    }
                })
        },
        methods: {
            hideLayer () {
                this.showSelectLayer = false
            },
            showSelect () {
                this.showSelectLayer = true
            },
            checkTelError () {
                this.isTelError = !checkTel(this.userTel)
            },
            checkAddress (address) {
                let reg = /^[0-9a-zA-Z]+$/
                return reg.test(address)
            },
            selectProvince (index) {
                this.checkProvinceIndex = index
                this.isSelectProvince = 'cur'
                this.provinceVal = this.cityList[index].p
                this.cityArr = this.cityList[index].c

                //城市重置
                this.checkCityIndex = null
                this.isSelectCity = ''
                this.cityVal = '请选择'

                //区域重置
                this.checkZoneIndex = null
                this.isSelectZone = ''
                this.zoneVal = '请选择'
                this.zoneArr = []
            },
            selectCity (index) {
                this.checkCityIndex = index
                this.isSelectCity = 'cur'
                this.cityVal = this.cityArr[index].n
                this.zoneArr = this.cityArr[index].a

                if (this.zoneArr === undefined) {
                    this.userAdd = `${this.provinceVal} ${this.cityVal}`
                    this.showSelectLayer = false
                }

                //区域重置
                this.checkZoneIndex = null
                this.isSelectZone = ''
                this.zoneVal = '请选择'
            },
            selectZone (index) {
                this.checkZoneIndex = index
                this.isSelectZone = 'cur'
                this.zoneVal = this.zoneArr[index].s

                this.userAdd = `${this.provinceVal} ${this.cityVal} ${this.zoneVal}`
                this.showSelectLayer = false
            },
            subInfo () {
                if (this.lockSubmit) return false
                this.lockSubmit = true
                if (this.userName === '') {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = '未填写收件人姓名'
                    this.msgShow = true
                    return false
                }
                if (this.userTel === '') {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = '未填写收件人手机号码'
                    this.msgShow = true
                    return false
                }
                if (!checkTel(this.userTel)) {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = '收件人手机号码有误'
                    this.msgShow = true
                    return false
                }
                if (this.userAdd === '') {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = '未选择省市区县、乡镇'
                    this.msgShow = true
                    return false
                }
                if (this.address === '') {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = '未填写街道、楼牌号等'
                    this.msgShow = true
                    return false
                }
                if (this.checkAddress(this.address)) {
                    this.msgType = 'error'
                    this.msgTitle = '出错啦'
                    this.msgTip = '请填写正确的地址信息'
                    this.msgShow = true
                    return false
                }
                let data = {
                    name: this.userName,
                    mob: this.userTel,
                    province: this.provinceVal,
                    city: this.cityVal,
                    districtCounty: this.zoneVal === '请选择' ? " " : this.zoneVal,
                    address: this.address,
                    zipCode: ''
                }
                // 显示loading
                this.loading = true
                if (this.queryObj.update) {
                    this.updateAddress(combineObject(data, {orderId: this.queryObj.orderId}))
                        .then(res => {
                            window.console.log(res)
                            if (res.errCode === 0) {
                                this.msgType = 'success'
                                this.msgTitle = '提交成功'
                                this.msgTip = '礼品将会尽快发出！'
                                this.msgShow = true
                            } else {
                                this.msgType = 'checking'
                                this.msgTitle = '待审核'
                                this.msgTip = '审核结果请于7天后查看'
                                this.msgShow = true
                            }
                        })
                } else {
                    this.placeOrder(combineObject(data, {productId: this.productId}))
                        .then(res => {
                            window.console.log(res)
                            if (res.errCode === 0) {
                                this.msgType = 'success'
                                this.msgTitle = '兑换成功'
                                this.msgTip = '礼品将会尽快发出！'
                                this.msgShow = true
                            } else {
                                this.msgType = 'checking'
                                this.msgTitle = '待审核'
                                this.msgTip = '审核结果请于7天后查看'
                                this.msgShow = true
                            }
                        })
                }
            },
            closeMsg () {
                this.msgShow = false
                this.lockSubmit = false
            },
            continueExchange () {
                this.$router.push('/member/shop/index')
            },
            see () {
                this.$router.push('/member/shop/gift')
            },
            getUserLevelPrivilege (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMProduct/GetDetailByIdAvailable',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            Id,
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getCustomerAddress () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMCommon/GetCustomerAddress',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            placeOrder (data) {
                try {
                    window.gio('track', 'RedeemSubmit', {'GiftID':this.productId});
                } catch (error) {
                    //console.log(error);
                }
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMOrder/PlaceOrder',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: data
                    })
                        .then(res => {
                            this.lockSubmit = false
                            this.loading = false
                            let _data = res.data
                            if (_data.errCode === 0 || _data.errCode === 10) {
                                resolve(_data)
                            } else if (_data.errCode === 1000 || _data.errCode === 1100) {
                                window.console.log(_data.errMsg)
                                this.msgType = 'error'
                                this.msgTitle = '出错啦'
                                this.msgTip = '系统开小差了，<br>晚点再回来看看吧！'
                                this.msgShow = true
                            } else {
                                window.console.log(_data.errMsg)
                                this.msgType = 'error'
                                this.msgTitle = '出错啦'
                                this.msgTip = _data.errMsg
                                this.msgShow = true
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            updateAddress (data) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMOrder/UpdateAddress',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: data
                    })
                        .then(res => {
                            this.loading = false
                            let _data = res.data
                            if (_data.errCode === 0 || _data.errCode === 10) {
                                resolve(_data)
                            } else if (_data.errCode === 1000) {
                                window.console.log('失败')
                                this.msgType = 'error'
                                this.msgTitle = '出错啦'
                                this.msgTip = '系统开小差了，<br>晚点再回来看看吧！'
                                this.msgShow = true
                            } else if (_data.errCode === 1100) {
                                window.console.log('系统错误')
                                this.msgType = 'error'
                                this.msgTitle = '出错啦'
                                this.msgTip = '系统开小差了，<br>晚点再回来看看吧！'
                                this.msgShow = true
                            } else {
                                this.msgType = 'error'
                                this.msgTitle = '出错啦'
                                this.msgTip = _data.errMsg
                                this.msgShow = true
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .page-title{
        color: #fff;
    }
    .receiving-info{
        height: 100vh;
        padding-top: 1.00rem;
        overflow-y: scroll;
        .pro-box{
            display: flex;
            display: -webkit-flex;
            padding-top: 0.30rem;
            padding-bottom: 0.30rem;
            background-color: #fff;
            border-bottom: #f5f6f8 solid 0.20rem;
            .pic-wrap{
                width: 2.25rem;
                height: 1.44rem;
                overflow: hidden;
                img{
                    width: 100%;
                    min-width: 1.44rem;
                }
            }
            .text-wrap{
                padding-left: 0.22rem;
                h3{
                    margin-bottom: 0.10rem;
                    font-weight: bold;
                    line-height: 0.32rem;
                }
                p{
                    color: #747d80;
                    line-height: 0.46rem;
                    .cur{
                        color: #ffa70d;
                    }
                    .black{
                        color: #282b2c;
                    }
                }
            }
        }
        .info-box{
            padding-top: 0.42rem;
            padding-bottom: 1.67rem;
            background-color: #fff;
            .item-title{
                height: 0.50rem;
                padding-bottom: 0.10rem;
                font-size: 0.30rem;
                .icon-line{
                    position: relative;
                    top: 0.01rem;
                    width: 0.04rem;
                    height: 0.30rem;
                    margin-right: 0.10rem;
                    background-color: #fbc500;
                    border-radius: 0.02rem;
                }
            }
            .item-detail{
                ul{
                    li{
                        height: 1.04rem;
                        border-bottom: #d4dbde solid 0.02rem;
                        &.error{
                            border-bottom-color: #f00;
                        }
                        span{
                            display: block;
                            width: 1.38rem;
                        }
                        input{
                            width: 5.48rem;
                            height: 0.64rem;
                            color: #282b2c;
                            &::placeholder{
                                color: #919b9f;
                            }
                            &:disabled{
                                background-color: transparent;
                            }
                        }
                    }
                }
            }
            .info-tip{
                padding-top: 0.20rem;
                color: #f00;
            }
        }
        .city-select{
            position: fixed;
            left: 0;
            top: 0;
            z-index: 101;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            .city-list{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 9.40rem;
                background-color: #fff;
                border-top-left-radius: 0.18rem;
                border-top-right-radius: 0.18rem;
                .list-title{
                    padding-top: 0.40rem;
                    font-size: 0.30rem;
                }
                .list-body{
                    display: flex;
                    display: -webkit-flex;
                    padding-top: 0.40rem;
                    padding-left: 0.34rem;
                    padding-right: 0.34rem;
                    .list-item{
                        &.list-p{
                            width: 30%;
                        }
                        &.list-c{
                            width: 35%;
                        }
                        &.list-z{
                            width: 35%;
                        }
                        .selected-wrap{
                            position: relative;
                            height: 0.74rem;
                            padding-bottom: 0.24rem;
                            margin: 0 0.16rem;
                            font-size: 0.30rem;
                            font-weight: bold;
                            line-height: 1;
                            span{
                                display: block;
                                position: absolute;
                                padding: 0.08rem 0.04rem;
                                max-width: 100%;
                                &.cur{
                                    border-bottom: #fbc500 solid 0.05rem;
                                }
                            }
                        }
                        .options-wrap{
                            height: 7.10rem;
                            font-size: 0.30rem;
                            overflow-y: scroll;
                            li{
                                position: relative;
                                height: 0.80rem;
                                padding: 0.16rem 0;
                                span{
                                    display: flex;
                                    display: -webkit-flex;
                                    align-items: center;
                                    -webkit-align-items: center;
                                    position: absolute;
                                    top: 0.16rem;
                                    height: 0.48rem;
                                    max-width: 100%;
                                    padding: 0 0.20rem;
                                    border-radius: 0.24rem;
                                    &.cur{
                                        background-color: #fbc500;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .bot-btn{
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 1.25rem;
            border-top: #d4dbde solid 0.02rem;
            background-color: #fff;
            .btn-submit{
                display: flex;
                display: -webkit-flex;
                width: 6.92rem;
                height: 0.95rem;
                border-radius: 0.07rem;
                background-color: #fbc500;
                font-size: 0.30rem;
            }
        }
    }
</style>
